import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { CustomToast } from "src/components/CustomToast";
import cmsClient from "src/services/cmsClient";

const patchObservationForm = async (
	payload: Partial<IAdminObservationForm>
) => {
	const { id, ...data } = payload;
	const url = `/observations/admin/forms/${id}/`;

	const response = await cmsClient.patch<IAdminObservationForm>(url, data);
	return response.data;
};

const usePatchObservationForm = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Form status updated" />,
			{
				hideProgressBar: true
			}
		);

		queryClient.invalidateQueries(["adminPublishedForms"]);
		queryClient.invalidateQueries(["adminDraftForms"]);
		queryClient.invalidateQueries(["observation-categories"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(patchObservationForm, {
		onSuccess,
		onError
	});

	return mutation;
};

export default usePatchObservationForm;
